import { useNotify, useRefresh, ArrayInput, SimpleFormIterator, SimpleForm, Button, SaveButton } from "react-admin";
import { Grid } from "@mui/material";
import { specialistRequests } from "api/specialistApi";
import dataProvider from "server/dataProvider";
import EmployeeOrExternalFields from "./EmployeeOrExternalFields";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import CloseIcon from "@mui/icons-material/Close";
import { useNotifyError } from "utils/useNotifyError";

const ExaminationHeadsForm = ({ record, setIsEditing }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();

  const handleSave = async data => {
    try {
      await dataProvider.customRequest(
        specialistRequests.updateAdvancedSpecializationExaminationHeads(record.id),
        { examinationHeads: data.examinationHeads },
        "PUT",
      );
      notify("Ръководителите на изпит са обновени успешно", { type: "success" });
      setIsEditing(false);
      refresh();
    } catch (err) {
      notifyError(err);
      handleConflictError(err);
    }
  };

  return (
    <>
      <SimpleForm
        key={`examination-heads-${record?.id}`}
        toolbar={false}
        onSubmit={handleSave}
        defaultValues={{ examinationHeads: [{}] }}
      >
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <ArrayInput
              source="examinationHeads"
              label=""
              fullWidth
            >
              <SimpleFormIterator
                inline
                fullWidth
              >
                <EmployeeOrExternalFields
                  professorLabel="Ръководител на изпит"
                  source="examinationHeads"
                  fullWidth
                />
              </SimpleFormIterator>
            </ArrayInput>
          </Grid>
        </Grid>
        <Grid sx={{ display: "flex", gap: 3, mt: 3 }}>
          <Button
            variant="outlined"
            startIcon={<CloseIcon />}
            color="error"
            size="small"
            label="Откажи"
            onClick={() => setIsEditing(false)}
          />
          <SaveButton
            label="Запази"
            size="small"
            alwaysEnable
          />
        </Grid>
      </SimpleForm>

      <ConflictErrorDialog />
    </>
  );
};

export default ExaminationHeadsForm;
